import { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Trophy, ExternalLink } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const medal = (i) => (i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : `#${i + 1}`);

/**
 * WeeklyLeaderboardStrip — compact tile for the admin dashboard.
 * Shows top 5 delivery staff this week + fleet total.
 */
export default function WeeklyLeaderboardStrip() {
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${API}/driver-trips/leaderboard?scope=week&limit=5`)
      .then((r) => setData(r.data))
      .catch(() => setData({ rows: [], collective_total: 0 }));
  }, []);
  if (!data) return null;

  return (
    <Card data-testid="weekly-leaderboard-strip">
      <CardHeader className="pb-2 flex flex-row items-center justify-between">
        <div>
          <CardTitle className="text-sm flex items-center gap-2">
            <Trophy className="h-4 w-4 text-amber-500" /> This Week — Top Delivery Staff
          </CardTitle>
          <div className="text-[11px] text-muted-foreground mt-1">
            Fleet total this week: <b className="text-indigo-700">{(data.collective_total || 0).toLocaleString('en-ZA')}</b> parcels
          </div>
        </div>
        <Link to="/admin/fleet-trips" className="text-xs text-indigo-600 hover:underline inline-flex items-center gap-1">
          Fleet Trips <ExternalLink className="h-3 w-3" />
        </Link>
      </CardHeader>
      <CardContent className="p-0">
        {!data.rows?.length ? (
          <div className="text-center py-4 text-xs text-muted-foreground">No parcel entries this week yet.</div>
        ) : (
          <div className="divide-y">
            {data.rows.map((r, i) => (
              <div key={r.driver_id} className="flex items-center gap-3 px-3 py-1.5" data-testid={`strip-row-${i}`}>
                <span className="text-lg w-7 text-center">{medal(i)}</span>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold truncate">{r.driver_name}</div>
                  <div className="text-[10px] text-muted-foreground">
                    {r.delivered} delivered · {r.collections} collected · {r.days}d
                  </div>
                </div>
                <Badge className="bg-amber-100 text-amber-800 border-amber-300" variant="outline">
                  {r.total.toLocaleString('en-ZA')}
                </Badge>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
